
import { defineComponent } from 'vue'
import { formatDate, parseISODate } from '~/utils/date'
export default defineComponent({
  name: 'BillingAlertScheduledCancel',
  props: {
    planName: {
      type: String,
      default: ''
    },
    // Nullable: upcomingCancellationDate can be absent depending on the subscription state,
    // so fall back to a generic phrasing instead of rendering "Invalid Date".
    cancellationDate: {
      type: String,
      default: null
    },
    // When the scheduled-to-cancel subscription is also past due, surface a payment-needed
    // note here so the unpaid balance isn't hidden behind a single cancel-only message.
    pastDue: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formattedCancellationDate(): string | null {
      if (!this.cancellationDate) return null
      const date = parseISODate(this.cancellationDate)
      if (isNaN(date.getTime())) return null
      return formatDate(date)
    }
  }
})
